/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { RequestBuilder } from '../../request-builder';
import { StrictHttpResponse } from '../../strict-http-response';

import { QuickSearchResponseDto } from '../../models/quick-search-response-dto';

export interface GetQuickSearchResults$Params {
  searchFor: string;
  from?: number;
  size?: number;
  searchTypes?: Array<string>;
}

export function getQuickSearchResults(
  http: HttpClient,
  rootUrl: string,
  params: GetQuickSearchResults$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<QuickSearchResponseDto>> {
  const rb = new RequestBuilder(rootUrl, getQuickSearchResults.PATH, 'get');
  if (params) {
    rb.query('searchFor', params.searchFor, {});
    rb.query('from', params.from, {});
    rb.query('size', params.size, {});
    rb.query('searchTypes', params.searchTypes, {});
  }

  return http
    .request(
      rb.build({ responseType: 'json', accept: 'application/json', context }),
    )
    .pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<QuickSearchResponseDto>;
      }),
    );
}

getQuickSearchResults.PATH = '/quick-search';
